<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.375 4.375H12.125C12.6773 4.375 13.125 4.82272 13.125 5.375V8.625C13.125 9.17728 12.6773 9.625 12.125 9.625H11.375M11.375 4.375V2.75C11.375 2.19772 10.9273 1.75 10.375 1.75H3.625C3.07272 1.75 2.625 2.19772 2.625 2.75V4.375M11.375 4.375V4.375C10.8918 4.375 10.5 4.76675 10.5 5.25V6.5625H3.5V5.25C3.5 4.76675 3.10825 4.375 2.625 4.375V4.375M2.625 4.375H1.875C1.32272 4.375 0.875 4.82272 0.875 5.375V8.625C0.875 9.17728 1.32272 9.625 1.875 9.625H2.625M2.625 9.625L2.1875 12.25M2.625 9.625H11.375M11.375 9.625L11.8125 12.25"
      stroke="var(--icon-border-default)"
      stroke-width="1.1"
    />
  </svg>
</template>
